module.exports = __webpack_public_path__ + "player.fe788876.png";